import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Selections } from "../../../../types/fixture";
import { ButtonContainer, BetButton } from "./styles";
import { RootState } from "../../../../reducers";
import { handleOddsFormat } from "../../../../helpers";
import { sendAnalyticsEvent } from "../../../../utils/sendAnalyticMessages";
import { Contestant } from "../../../../types/fixture";
import { SPORTS_MAP } from "../../../../constants";

interface Props {
  selections: Selections[];
  market: string;
  competition: string;
  eventContestants: Contestant[];
}

interface bet {
  eventId: string;
  commonId: number;
  oddsDecimal: number;
  name: string;
  type: string;
  handicap: string;
}

interface match {
  eventid: string;
  commonId: number;
}

function FixtureBetButton({
  selections,
  market,
  competition,
  eventContestants,
}: Props): JSX.Element {
  const { activeOddsFormat } = useSelector((state: RootState) => state.app);
  const betslipStore = useSelector((state: RootState) => state.betslip);
  const filterStore = useSelector((state: RootState) => state.filter);
  const dispatch = useDispatch();
  const parentURL = document.referrer
    ? document.referrer
    : window.location.ancestorOrigins?.[0];

  const updateBetslip = (bet: bet) => {
    if (!betslipStore) return;

    const selectionsLength =
      betslipStore.selections.length >= 0 &&
      betslipStore.selections.length < 20;

    const selectionName = eventContestants.find(
      (contestant) => contestant.code === bet.name
    )?.name;

    const eventLocation = eventContestants.find(
      (contestant) => contestant
    )?.location;

    if (
      selectionsLength &&
      !betslipStore.selections.some(
        (match: match) => match.eventid === bet.eventId
      )
    ) {
      dispatch({
        type: "ADD_SELECTION_TO_BETSLIP",
        payload: {
          eventid: bet.eventId,
          commonId: bet.commonId,
          oddsDecimal: bet.oddsDecimal,
          market,
        },
      });

      sendAnalyticsEvent(
        {
          event: "add_to_betslip",
          bet_sport: SPORTS_MAP.get(competition),
          bet_competition: competition,
          bet_event: `${eventContestants[1].name} @ ${eventLocation}`,
          source: "Smart Picks",
          bet_selection: selectionName
            ? `${selectionName} ${bet.type}`
            : `${bet.type} ${bet.handicap?.replace(/\+/g, "") || ""}`,
        },
        parentURL
      );
    }
    if (
      selectionsLength &&
      betslipStore.selections?.some(
        (match: match) =>
          match.eventid === bet.eventId && match.commonId === bet.commonId
      )
    ) {
      dispatch({
        type: "REMOVE_SELECTION_FROM_BETSLIP",
        payload: {
          eventid: bet.eventId,
        },
      });

      sendAnalyticsEvent(
        {
          event: "remove_from_betslip",
          bet_sport: SPORTS_MAP.get(competition),
          bet_competition: competition,
          bet_event: `${eventContestants[1].name} @ ${eventLocation}`,
          bet_selection: selectionName
            ? `${selectionName} ${bet.type}`
            : `${bet.type} ${bet.handicap?.replace(/\+/g, "") || ""}`,
        },
        parentURL
      );
    }
    if (
      selectionsLength &&
      betslipStore.selections?.some(
        (match: match) =>
          match.eventid === bet.eventId && match.commonId !== bet.commonId
      )
    ) {
      dispatch({
        type: "UPDATE_MATCH_SELECTION",
        payload: {
          eventid: bet.eventId,
          commonId: bet.commonId,
          oddsDecimal: bet.oddsDecimal,
        },
      });
    }
  };

  const handleOddsButtonLabel = (market: string, selection: Selections) => {
    switch (filterStore.market) {
      case "ML":
        return selection.name;
      case "TOTAL":
        return `${selection.name} ${selection.handicap?.replace(/\+/g, "") || ""
          }`;
      case "SPREAD":
        return `${selection.name} ${selection.handicap ? selection.handicap : ""
          }`;
      case "FTS":
      case "ATS":
      case "FBS":
      case "PDD":
      case "PTDD":
        return market;
      case "PY":
      case "REY":
      case "RUY":
      case "PP":
      case "PR":
      case "PA":
      case "PT":
      case "PPA":
      case "PPR":
      case "PAR":
      case "PTO":
      case "PBS":
      case "PS":
        return `${selection.type} ${selection.handicap?.replace(/\+/g, "") || ""}`;
      default:
        return null;
    }
  };

  return (
    <ButtonContainer>
      {selections.map((selection, index) => (
        <BetButton
          active={
            betslipStore.selections.length > 0 &&
            betslipStore.selections.some(
              (match: match) =>
                match.eventid === selection.eventId &&
                match.commonId === selection.commonId
            )
          }
          uppercase={
            filterStore.market === "SPREAD" || filterStore.market === "ML"
          }
          key={index}
          onClick={() => updateBetslip(selection)}
        >
          <span>{handleOddsButtonLabel(market, selection)}</span>
          <span>
            {handleOddsFormat(
              activeOddsFormat,
              selection.odds,
              selection.oddsDecimal,
              selection.oddsFractional
            )}
          </span>
        </BetButton>
      ))}
    </ButtonContainer>
  );
}

export default FixtureBetButton;
